module.exports = __webpack_public_path__ + "img/welcome.7e9f5c6b.svg";